import { Resource } from 'model/Resource';
import { PerspectivesListModel } from 'api/dto/new/Perspectives/PerspectiveListDto';
import { PerspectiveModel } from 'api/dto/new/Perspectives/Perspective.dto';
import { CustomAvatarModel } from 'api/dto/new/Perspectives/CustomAvatar.dto';
import { PerspectiveSummaryModel } from 'api/dto/new/Perspectives/PerspectiveSummary.dto';
import { AIAvatarsModel } from 'api/dto/AIAvatar.dto';
import { PerspectivesDepartmentModel } from 'api/dto/new/Perspectives/DepartmentsListResult.dto';

export const STORE_NAME = 'perspectives';

export namespace PerspectivesState {
  export type Domain = {
    list: Resource<PerspectivesListModel | null>;
    selected: Resource<PerspectiveModel | null>;
    topics: Resource<string[] | null>;
    departments: Resource<PerspectivesDepartmentModel | null>;
    customAvatars: Resource<CustomAvatarModel[] | null>;
    summary: Resource<PerspectiveSummaryModel | null>;
    aiAvatar: Resource<AIAvatarsModel | null>;
    accessMap: Record<string, boolean>;
  };

  export const INITIAL_DOMAIN: PerspectivesState.Domain = {
    list: Resource.createPendingResource<PerspectivesListModel | null>(),
    selected: Resource.createPendingResource<PerspectiveModel | null>(),
    topics: Resource.createPendingResource<string[] | null>(),
    departments: Resource.createPendingResource<PerspectivesDepartmentModel | null>(),
    customAvatars: Resource.createPendingResource<CustomAvatarModel[] | null>(),
    summary: Resource.createPendingResource<PerspectiveSummaryModel | null>(),
    aiAvatar: Resource.createPendingResource<AIAvatarsModel | null>(),
    accessMap: {},
  };
}
